import * as React from 'react';
import { UploadServiceSettingsProvider } from '@davies-group/document-upload-lib';
import { ThemeProvider } from '@davies-group/white-label-ui/theme'
import { StyledEngineProvider } from '@mui/material/styles';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { History } from 'history';

import AppContainerLoading from './AppContainerLoading';
import  AppMain  from './AppMain';
import { useAssessmentContext } from './context';

declare global 
{
	interface Window 
	{
		__appSettings: any
	}
}

const reactPlugin = new ReactPlugin();

type State = {
	applicationInsights?: ApplicationInsights
}

const defaultState: State = {};

type AppProps = {
	history: History;
};

function App(props: AppProps)
{
	const [state, setState] = React.useState(defaultState);
	const assessmentContext = useAssessmentContext();

	React.useEffect(() => 
	{
		if (state.applicationInsights)
			return;

		const applicationInsights = new ApplicationInsights({
			config: {
				instrumentationKey: window.__appSettings.applicationInsightsInstrumentationKey,
				extensions: [reactPlugin],
				extensionConfig: {
					[reactPlugin.identifier]: { history: props.history }
				}
			}
		});
		applicationInsights.loadAppInsights();
		setState({ applicationInsights });
	}, []);

	return (
		<StyledEngineProvider injectFirst>
			{
				assessmentContext.assessment ? <ThemeProvider
					apiUrl={window.__appSettings.apiEndpoints.brandingApi}
					brandId={assessmentContext.assessment.brandId}
					clientId={assessmentContext.assessment.clientId}>
					<UploadServiceSettingsProvider
						apiUploadEndpoint={`${window.__appSettings.apiEndpoints.documentApi}/upload`}
						apiDeleteEndpoint={`${window.__appSettings.apiEndpoints.documentApi}/delete`}
						uploadInstructionTextEmpty="Please select or drag and drop the file(s) you wish to upload"
						uploadInstructionTextPopulated="Please select or drag and drop any additional file(s) you also wish to upload"
						fileTooLargeText="The file is too large, this file will not be uploaded."
						unknownErrorText="Something went wrong."
						fileCountLimitReachedText="Maximum number of files has been reached.">
						<AppMain />
					</UploadServiceSettingsProvider>
				</ThemeProvider>: <AppContainerLoading />
			}
		</StyledEngineProvider>
	);
}

export default withAITracking(reactPlugin, App);
